module.exports = __webpack_public_path__ + "img/nick-chin.0d306826.png";